export const cancelEventFormField = [
	{
		type: 'text',
		title: 'Cancel Event Reason',
		placeholder: 'Enter reason for cancelation',
		formControlName: 'cancelEventReason',
		required: true,
		maxLength: 200,
		errorsMsg: [
			{ type: 'required', message: 'Cancel reason is required' },
			{
				type: 'maxlength',
				message: 'Reason should be less than 200 characters',
			},
		],
	},
	{
		type: 'text',
		title: 'User Id',
		placeholder: 'User Id',
		formControlName: 'userId',
		required: true,
		disabled: true,
		errorsMsg: [{ type: 'required', message: 'User Id is required' }],
	},
	{
		type: 'text',
		title: 'Post Id',
		placeholder: 'Post Id',
		formControlName: 'postId',
		required: true,
		disabled: true,
		errorsMsg: [{ type: 'required', message: 'Post Id is required' }],
	},
];
